export const cableEquipmentColumns = [
    { title: "PN", key: "pn" },
    { title: "Length (ft)", key: "totalLength" },
    { title: "Weight (lbs)", key: "nominalWeight" },
    { title: 'Dim. (T"xW")', key: "dimensions", },
];

export const cableMotorLockEquipmentColumns = [
    { title: "PN", key: "pn" },
    { title: "Length (ft)", key: "length" },
    { title: "Weight (lbs)", key: "weight" },
    { title: 'Dim. (T"xW")', key: "dimension", },
];